class RecipientForm extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.toggle = this.querySelector('[data-toggle]')
    this.hiddenControlField = this.querySelector(
      '#Recipient-control-main-product',
    )
    this.hiddenControlField.disabled = true
    this.emailInput = this.querySelector('#propertiesFormRecipientEmail')
    this.emailConfirmationInput = this.querySelector(
      '#propertiesFormRecipientEmailConfirmation',
    )
    this.nameInput = this.querySelector('#propertiesFormRecipientName')
    this.messageInput = this.querySelector('#propertiesFormMessage')
    this.sendonInput = this.querySelector('#propertiesFormSendOn')
    this.offsetProperty = this.querySelector(
      '#Recipient-timezone-offset-main-product',
    )
    this.recipientCheckbox = this.querySelector(
      '#Recipient-checkbox-main-product',
    )

    if (this.offsetProperty) {
      this.offsetProperty.value = new Date().getTimezoneOffset()
    }

    this.requiredFields = Array.from(
      this.querySelectorAll(
        'input[required], textarea[required], select[required]',
      ),
    )

    this.currentProductVariantId = this.dataset.productVariantId
  }

  initialise () {
    super.initialise()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.toggle, 'toggle', this.onChange.bind(this))

    if (this.emailInput && this.emailConfirmationInput) {
      this.listeners.add(
        this.emailInput,
        'input',
        this.validateEmailMatch.bind(this),
      )
      this.listeners.add(
        this.emailConfirmationInput,
        'input',
        this.validateEmailMatch.bind(this),
      )
    }
  }

  validateEmailMatch () {
    if (!this.emailInput || !this.emailConfirmationInput) return

    const emailValue = this.emailInput.value.trim()
    const confirmationValue = this.emailConfirmationInput.value.trim()

    if (confirmationValue) {
      if (emailValue !== confirmationValue) {
        this.emailConfirmationInput.setCustomValidity('Emails do not match')
      } else {
        this.emailConfirmationInput.setCustomValidity('')
      }
    } else {
      this.emailConfirmationInput.setCustomValidity('')
    }
  }

  validateSubmission () {
    if (this.toggle && this.toggle.hasAttribute('open')) {
      const emailValue = this.emailInput?.value.trim() || ''
      const confirmationValue = this.emailConfirmationInput?.value.trim() || ''

      if (confirmationValue && emailValue !== confirmationValue) {
        this.emailConfirmationInput.setCustomValidity('Emails do not match')
        this.emailConfirmationInput.reportValidity()
        return false
      }
    }

    return true
  }

  onChange () {
    if (this.toggle.hasAttribute('open')) {
      this.enableRecipientCheckbox()
      this.enableInputFields()
    } else {
      this.clearInputFields()
      this.disableInputFields()
      this.disableRecipientCheckbox()
    }
  }

  inputFields () {
    return [
      this.emailInput,
      this.emailConfirmationInput,
      this.nameInput,
      this.messageInput,
      this.sendonInput,
    ]
  }

  disableableFields () {
    return [...this.inputFields(), this.offsetProperty, this.recipientCheckbox]
  }

  clearInputFields () {
    this.inputFields().forEach(field => {
      if (field) {
        if (this.requiredFields.includes(field)) {
          field.setAttribute('required', 'required')
        }

        field.value = ''
      }
    })
  }

  enableInputFields () {
    this.disableableFields().forEach(field => {
      if (field) {
        if (this.requiredFields.includes(field)) {
          field.setAttribute('required', 'required')
        }

        field.disabled = false
      }
    })
  }

  disableInputFields () {
    this.disableableFields().forEach(field => {
      if (field) {
        if (this.requiredFields.includes(field)) {
          field.removeAttribute('required')
        }

        field.disabled = true
      }
    })
  }

  enableRecipientCheckbox () {
    this.recipientCheckbox.value = true
  }

  disableRecipientCheckbox () {
    this.recipientCheckbox.value = false
  }

  resetRecipientForm () {
    if (this.toggle.hasAttribute('open')) {
      this.toggle.removeAttribute('open')
      this.clearInputFields()
      this.disableRecipientCheckbox()
    }
  }
}

if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', RecipientForm)
}
